import type { FeatureModule } from "../types";
import { Campaigns } from "./Campaigns";

export const campaignsFeature: FeatureModule = {
  id: "campaigns",
  path: "/campaigns",
  label: "Campaigns",
  nav: false,
  element: Campaigns,
};

export { Campaigns } from "./Campaigns";
